import { render } from "./ArchiveSearchView.vue?vue&type=template&id=3a04c97c&scoped=true&ts=true"
import script from "./ArchiveSearchView.vue?vue&type=script&lang=ts"
export * from "./ArchiveSearchView.vue?vue&type=script&lang=ts"

import "./ArchiveSearchView.vue?vue&type=style&index=0&id=3a04c97c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a04c97c"]])

export default __exports__